import React from "react";
import { Layout } from '../../components/Layout';
import WillBeBackPage from '../WillBeBackPage'

function BuyAppleVisionPro(){
    return(
        <Layout bgThemeVariant="light" iconColor="gray">
            <WillBeBackPage
                pageContent='Apple Vision Pro STORE'
            />
   
        </Layout>
    )
}

export default BuyAppleVisionPro;